
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trading-competition-v4",
      function () {
        return require("private-next-pages/trading-competition-v4/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trading-competition-v4"])
      });
    }
  